import type { BreakpointUnknown, Breakpoint } from "../breakpoint/types";

/**
 *
 *
 *
 */
export const setDevSpecsCookie = (bp: Breakpoint | BreakpointUnknown | undefined): void => {
  /*                                       */
  if (!bp) return;

  const { clientHeight, clientWidth } = document.documentElement;

  const cookieValue = `w=${clientWidth}&h=${clientHeight}&bp=${bp}`;
  const expireDate = new Date();
  expireDate.setTime(expireDate.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);

  document.cookie = `devSpecs=${cookieValue};path=/;domain=.otto.de;expires=${expireDate.toUTCString()}`;
};
